import _classCallCheck from "/opt/build/repo/docs/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/opt/build/repo/docs/node_modules/@babel/runtime/helpers/esm/createClass.js";
var Transformer = /*#__PURE__*/function () {
  function Transformer() {
    _classCallCheck(this, Transformer);
  }
  _createClass(Transformer, [{
    key: "getPrefixCode",
    value:
    // Return true if anything was processed, false otherwise.

    function getPrefixCode() {
      return "";
    }
  }, {
    key: "getHoistedCode",
    value: function getHoistedCode() {
      return "";
    }
  }, {
    key: "getSuffixCode",
    value: function getSuffixCode() {
      return "";
    }
  }]);
  return Transformer;
}();
export { Transformer as default };